const SOCIAL_CONTACT_LINKS = {
  telegram: 'https://t.me/sportvokrug_official',
  vk: 'https://vk.com/sportvokrug',
  youtube: 'https://www.youtube.com/@Sportaround',
}

export default SOCIAL_CONTACT_LINKS
